import { apiClient } from "./client";
import type { Group } from "./types";

export async function fetchAccountGroups(): Promise<Group[]> {
  const response = await apiClient.get<Group[]>("/v1/account/groups");
  return response.data;
}
